const SearchBar = ({
  searchValue,
  searchBtnColor,
  onSearchChange,
  onSearch,
}) => {
  return (
    <div className="searchBar">
      <p className="searchBarLabel">Search by car brand</p>
      <div className="searchBarInner">
        <label className="searchInputWrapper">
          <input
            type="search"
            value={searchValue}
            placeholder="EX:BMW,Audi,Tesla..."
            onChange={onSearchChange}
          />
        </label>

        <button
          className="searchBtnStyle"
          style={{ backgroundColor: searchBtnColor }}
          onClick={onSearch}
        >
          Search
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
